import Logo from './Logo'
export default Logo



// WEBPACK FOOTER //
// ./src/elements/logo/index.js